import { render, staticRenderFns } from "./AcademicLoadTable.vue?vue&type=template&id=4b53ff2a&scoped=true"
import script from "./AcademicLoadTable.vue?vue&type=script&setup=true&lang=js"
export * from "./AcademicLoadTable.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AcademicLoadTable.vue?vue&type=style&index=0&id=4b53ff2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b53ff2a",
  null
  
)

export default component.exports